export default "__VITE_ASSET__XDx_YV0A__"